
import getmainurl from "./tools.service";

const getInstanceName = () => {
    if (getmainurl().includes('localhost')) {
        return 'localhost';
    }
    return getmainurl().substring(getmainurl().indexOf('://')+3, getmainurl().indexOf('-racing')).toUpperCase();
}

// default export ---------------------------------------------------
const instance = {
    getInstanceName
};

export default instance;